import { House } from 'lucide-react';
import { BreadCrumb } from 'primereact/breadcrumb';
import { FC, Suspense } from 'react';
import { Link } from 'react-router-dom';
import { ThreeDotLoader } from '../../Fallback/ThreeDotsLoader';
import TeacherDiagnosticPrepDiagnosticContent from './TeacherDiagnosticPrepDiagnosticContent';
import TeacherDiagnosticPrepDiagnosticQuickFacts from './TeacherDiagnosticPrepDiagnosticQuickFacts';

const TeacherDiagnosticPrepDiagnosticWrapper: FC = () => {
  const breadcrumbItems = [
    {
      template: () => <span className="tw-flex tw-font-atkinson tw-text-neutral-700">Guided Walkthroughs</span>,
    },
    {
      template: () => (
        <span className="tw-flex tw-font-atkinson tw-text-neutral-700 tw-font-bold">Prepare for the diagnostic</span>
      ),
    },
  ];

  const home = {
    template: () => (
      <Link
        to={'/'}
        className="tw-flex tw-items-center tw-gap-2 tw-cursor-pointer tw-font-atkinson tw-text-neutral-700"
      >
        <House className="tw-text-blue-500" /> Home
      </Link>
    ),
  };

  return (
    <Suspense fallback={<ThreeDotLoader dark />}>
      <div style={{ overflowX: 'hidden' }} className={`nc_page-inner xl:tw-w-10/12 tw-mx-auto tw-w-11/12`}>
        <BreadCrumb model={breadcrumbItems} home={home} className="col-12 col-offset-0 tw-py-0" />
        <h1 className="tw-text-2xl tw-text-neutral-950 tw-font-sora tw-font-bold tw-my-6 tw-pb-4 tw-border-b-[2px] tw-border-t-[0px] tw-border-x-[0px] tw-border-neutral-100 tw-border-solid ">
          Prepare for the diagnostic
        </h1>
        <TeacherDiagnosticPrepDiagnosticQuickFacts />
        <TeacherDiagnosticPrepDiagnosticContent />
      </div>
    </Suspense>
  );
};

export default TeacherDiagnosticPrepDiagnosticWrapper;
